
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthGuard } from './../route-guards/auth/auth.guard';
import { RegionsListGuard } from './login/regions-list-guard'

import { CampaignListComponent } from './campaign/list/list.component';
import { CampaignGuard } from './campaign/campaign.guard';
import { CampaignListGuard } from './campaign/campaign-list.guard';
import { CampaignFormComponent } from './campaign/form/form.component';


import { CampaignTransactionsComponent } from './campaign/campaign-transactions/campaign-transactions.component';


const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'transactions',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CampaignTransactionsComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/app-routing.module.ts